"use client";

import { Icon } from "@iconify/react";
import { Button, DropdownMenuTrigger } from "@/components/ui";
import { TOGGLE_NAVBAR_TRIGGER_CLASSES, TOGGLE_SIDEBAR_HEADER_TRIGGER_CLASSES } from "./styles";
import type { ToggleTriggerAs } from "./types";

type ToggleDropdownTriggerProps = {
  triggerAs: ToggleTriggerAs;
  ariaLabel: string;
  icon: string;
};

export const ToggleDropdownTrigger = ({
  triggerAs,
  ariaLabel,
  icon,
}: ToggleDropdownTriggerProps) => {
  const triggerClassName =
    triggerAs === "sidebar-header"
      ? TOGGLE_SIDEBAR_HEADER_TRIGGER_CLASSES
      : TOGGLE_NAVBAR_TRIGGER_CLASSES;

  return (
    <DropdownMenuTrigger
      render={(props) => (
        <Button
          variant="ghost"
          size="icon-lg"
          className={triggerClassName}
          aria-label={ariaLabel}
          {...props}
        >
          <Icon icon={icon} className="size-5 shrink-0" />
        </Button>
      )}
    />
  );
};
